import axios from '../core/axios';
import { ApiConstants } from './api-constants';

export class DocumentsService {
  static getPresigned = async (clientId: string, params: URLSearchParams) => {
    return await (
      await axios.get(ApiConstants.FILES_API.GET_PRESIGNED.URL(clientId, params))
    ).data;
  };
  static uploadDocument = async (url: string, formData: FormData) => {
    return await (
      await axios.post(url, formData)
    ).data;
  };
  static getDocuments = async (clientId: string) => {
    return await (
      await axios.get(ApiConstants.FILES_API.GET_FILES.URL(clientId))
    ).data;
  };
  static getDocumentDetails = async (clientId: string, fileId: string) => {
    return await (
      await axios.get(ApiConstants.FILES_API.GET_FILE_DETAILS.URL(clientId, fileId))
    ).data;
  };
  static downloadDocument = async (clientId: string, fileId: string) => {
    return await (
      await axios.get(ApiConstants.FILES_API.DOWNLOAD_FILE.URL(clientId, fileId))
    ).data;
  };
  static shareDocument = async (clientId: string, fileId: string, payload: any) => {
    return await (
      await axios.post(ApiConstants.FILES_API.SHARE_FILE.URL(clientId, fileId), payload)
    ).data;
  };
  static deleteDocument = async (clientId: string, fileId: string) => {
    return await (
      await axios.delete(ApiConstants.FILES_API.DELETE_FILE.URL(clientId, fileId))
    ).data;
  };
  static renameDocument = async (clientId: string, fileId: string, newName: string) => {
    return await (
      await axios.patch(
        ApiConstants.FILES_API.RENAME_FILE.URL(clientId, fileId),
        JSON.stringify({
          fileName: newName,
        }),
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
    ).data;
  };
}
